import { CountryCode } from '../../i18n/countryCodes'
import { ICountry } from './index'

export default function fetchCountry(api: GlobalFetch) {
  return function(lang: CountryCode) {
    return api
      .fetch(`/api/v2/misc/country/lang/${lang}`)
      .then((res): Promise<IData> => res.json())
      .then((res): ICountry[] =>
        res.items.map(
          (item): ICountry => {
            return {
              code: item.code,
              id: item.id,
              name: item.name,
            }
          },
        ),
      )
  }
}

interface IData {
  items: ICountryData[]
  messages: string[]
}

interface ICountryData {
  id: number
  name: string
  code: string
}
